import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const TermsAndConditionsPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-slate-300 p-4 md:p-8 font-sans relative overflow-hidden">

            {/* Effetti di sfondo decorativi */}
            <div className="fixed top-[-10%] left-[-10%] w-96 h-96 bg-sky-500/10 rounded-full blur-3xl pointer-events-none z-0"></div>
            <div className="fixed bottom-[-10%] right-[-10%] w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none z-0"></div>

            <div className="max-w-4xl mx-auto relative z-10">

                {/* Header Page */}
                <div className="flex items-center justify-between mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 text-slate-400 hover:text-sky-400 transition-colors duration-300 bg-slate-800/50 px-4 py-2 rounded-lg border border-slate-700/50 hover:bg-slate-800"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Indietro
                    </button>
                    <div className="text-right">
                        <Link to="/" className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-emerald-400 tracking-tight">
                            QrFlow
                        </Link>
                    </div>
                </div>

                {/* Content Box */}
                <div className="bg-slate-800/60 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-6 md:p-10 shadow-2xl">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-2">Termini e Condizioni</h1>
                    <p className="text-sm text-slate-400 mb-8 border-b border-slate-700/50 pb-4">Ultimo aggiornamento: Ottobre 2023</p>

                    <div className="space-y-8 text-slate-300 leading-relaxed">

                        {/* Sezione 1: Introduzione */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" /></svg>
                                1. Introduzione e Accettazione
                            </h2>
                            <p className="mb-3">
                                I presenti Termini e Condizioni disciplinano l'utilizzo dell'applicazione web <strong>QrFlow</strong>. L'accesso e l'uso della piattaforma comportano l'accettazione integrale dei seguenti termini.
                            </p>
                            <div className="bg-slate-900/50 rounded-xl p-5 border border-slate-700/50 mt-4">
                                <p>Il servizio è gestito e fornito da:</p>
                                <ul className="mt-2 space-y-1 font-medium text-slate-200">
                                    <li><span className="text-slate-400">Nome:</span> Fatima Boukhama (operante come AxiomGroup)</li>
                                    <li><span className="text-slate-400">P.IVA:</span> 04717560983</li>
                                    <li><span className="text-slate-400">Sede Legale:</span> Via Fabio Filzi 37, Brescia (BS), Italia</li>
                                </ul>
                            </div>
                        </section>

                        {/* Sezione 2: Descrizione del Servizio */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
                                2. Descrizione del Servizio
                            </h2>
                            <p>
                                QrFlow è una piattaforma software che permette agli utenti (con diversi livelli di accesso come Amministratori o Clienti) di generare, organizzare in gruppi e gestire QR Code, oltre a monitorare log e statistiche relativi alle loro scansioni. Le funzionalità specifiche disponibili dipendono dal piano sottoscritto o dai permessi accordati dall'Amministratore.
                            </p>
                        </section>

                        {/* Sezione 3: Account e Sicurezza */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" clipRule="evenodd" /></svg>
                                3. Registrazione e Sicurezza dell'Account
                            </h2>
                            <ul className="list-disc list-inside space-y-2 ml-2">
                                <li>L'utente è tenuto a fornire informazioni veritiere e aggiornate durante la registrazione o l'invito.</li>
                                <li>L'utente è l'unico responsabile della riservatezza delle proprie credenziali di accesso.</li>
                                <li>AxiomGroup non sarà responsabile per eventuali danni derivanti dall'accesso non autorizzato al tuo account dovuto alla mancata protezione della tua password.</li>
                            </ul>
                        </section>

                        {/* Sezione 4: Uso Consentito */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                4. Regole di Condotta e Uso Consentito
                            </h2>
                            <p className="mb-2">L'utente si impegna a non utilizzare QrFlow per:</p>
                            <ul className="list-disc list-inside space-y-2 ml-2">
                                <li>Generare QR Code che reindirizzano a contenuti illeciti, fraudolenti, malevoli (malware/phishing) o offensivi.</li>
                                <li>Violare diritti d'autore, marchi o altre proprietà intellettuali di terzi.</li>
                                <li>Tentare di compromettere la sicurezza, l'integrità o il funzionamento tecnico dell'applicazione.</li>
                            </ul>
                            <p className="mt-3 text-red-400 text-sm">
                                <em>La violazione di queste regole comporterà la sospensione o cancellazione immediata dell'account a nostra insindacabile discrezione.</em>
                            </p>
                        </section>

                        {/* Sezione 5: Responsabilità */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
                                5. Limitazione di Responsabilità
                            </h2>
                            <p>
                                QrFlow viene fornito "così com'è" e "come disponibile". AxiomGroup non garantisce che il servizio sarà ininterrotto o privo di errori. Nei limiti consentiti dalla legge, non saremo responsabili per perdite di dati, mancati profitti o danni indiretti derivanti dall'utilizzo o dall'impossibilità di utilizzare la piattaforma.
                            </p>
                        </section>

                        {/* Sezione 6: Foro Competente */}
                        <section>
                            <h2 className="text-xl font-semibold text-sky-400 mb-3 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" /></svg>
                                6. Legge Applicabile e Foro Competente
                            </h2>
                            <p>
                                I presenti Termini sono regolati dalla legge italiana. Qualsiasi controversia derivante o relativa all'utilizzo di QrFlow, che non possa essere risolta in via amichevole, sarà di competenza esclusiva del <strong>Foro di Brescia</strong> (Italia).
                            </p>
                        </section>

                        {/* Contatti */}
                        <section className="pt-4 border-t border-slate-700/50">
                            <p>
                                Per domande, segnalazioni o assistenza relativa a questi Termini, puoi contattarci all'indirizzo email:{' '}
                                <a href="mailto:sviluppo@axiomgroup.it" className="text-emerald-400 font-semibold hover:text-emerald-300 transition-colors">sviluppo@axiomgroup.it</a>
                            </p>
                        </section>

                    </div>
                </div>

                {/* Footer AxiomGroup */}
                <div className="mt-8 text-center pb-8">
                    <p className="text-sm text-slate-500 font-medium tracking-wide">
                        &copy; {new Date().getFullYear()} QrFlow. Gestito da{' '}
                        <a
                            href="https://axiomgroup.it"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sky-500 hover:text-sky-400 transition-colors duration-300 hover:underline decoration-sky-500/50 underline-offset-4"
                        >
                            AxiomGroup
                        </a>
                    </p>
                </div>

            </div>
        </div>
    );
};

export default TermsAndConditionsPage;